var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6667 18.5218V17.1305C17.6667 16.3925 17.3857 15.6847 16.8856 15.1629C16.3855 14.6411 15.7072 14.3479 15 14.3479H9.66667C8.95942 14.3479 8.28115 14.6411 7.78105 15.1629C7.28095 15.6847 7 16.3925 7 17.1305V18.5218",
    stroke: "#504D56",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3334 11.5652C13.8062 11.5652 15.0001 10.3194 15.0001 8.78261C15.0001 7.24582 13.8062 6 12.3334 6C10.8607 6 9.66675 7.24582 9.66675 8.78261C9.66675 10.3194 10.8607 11.5652 12.3334 11.5652Z",
    stroke: "#504D56",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.6fbb00a6ade5bab69e1936ac1e480bc0.svg";
export { ForwardRef as ReactComponent };